module.exports = __webpack_public_path__ + "img/Doc16a.2_20070019-001_18 Aug 1915_2.165816d2.jpg";